import type { AntennasCatalog, DevicesCatalog, MarketplaceProductsCatalog } from './types';
import antennaLTEImage from '../assets/antenna.webp';
import antennaLTEThumb from '../assets/antenna-thumbnail.webp';
import pos5Image from '../assets/pos-5.webp';
import pos5Thumb from '../assets/pos-5-thumbnail.webp';
import proImage from '../assets/pro.webp';
import proThumb from '../assets/pro-thumbnail.webp';
import miniImage from '../assets/mini.webp';
import miniThumb from '../assets/mini-thumbnail.webp';
import compactImage from '../assets/compact.webp';
import compactThumb from '../assets/compact-thumbnail.webp';
import masterImage from '../assets/master.webp';
import masterThumb from '../assets/master-thumbnail.webp';

export const ANTENNAS_CATALOG: AntennasCatalog = {
	antennaLTE: {
		id: 'antennaLTE',
		name: 'Antena LTE',
		image: antennaLTEImage,
		imageThumb: antennaLTEThumb,
		available: true,
	},
};

export const DEVICES_CATALOG: DevicesCatalog = {
	pos5: {
		id: 'pos5',
		name: 'Frekuent spot POS 5',
		image: pos5Image,
		imageThumb: pos5Thumb,
		available: true,
		connectivity: [
			{ type: 'gsm', value: 'LTE, UMTS/HSPA, GSM/GPRS/EDGE' },
			{ type: 'wifi', value: 'WiFi 2.4/5 GHz' },
			{ type: 'bluetooth', value: 'BT 2.1+EDR/3.0/4.1 LE/4.2 BLE' },
		],
		paymentMethods: ['card', 'google', 'apple', 'nfcTags', 'frekuentApp'],
		dimensions: '175 × 20 × 98 mm',
		ports: '1× USB-C OTG + 1× RS232 + 1× EXE/MDB Slave + 1× EXE/MDB Master',
		nfcReader: 'Mifare 1K/4K, Mifare DESFire',
		powerSupply: '34 VDC / 24 VAC',
		operatingSystem: 'Android 10',
	},
	posPro: {
		id: 'posPro',
		name: 'Frekuent spot Pro',
		image: proImage,
		imageThumb: proThumb,
		available: false,
		connectivity: [
			{ type: 'gsm', value: 'LTE, UMTS/HSPA, GSM/GPRS/EDGE' },
			{ type: 'wifi', value: 'WiFi 2.4/5 GHz' },
			{ type: 'bluetooth', value: 'Bluetooth 5.0' },
		],
		paymentMethods: ['card', 'google', 'apple', 'nfcTags', 'frekuentApp'],

		dimensions: '183 × 96 × 22 mm',
		ports:
			'1× USB 3.0-C + 2× RS232, 1× EXE/MDB Master + 1× EXE/MDB Peripheral, NanoSIM + eSIM, microSD',
		nfcReader: 'ISO 14443-A/B, Mifare, FeliCa, EMVCo 3.1, Apple VAS',
		powerSupply: '34 VDC / 24 VAC, 2 A',
		operatingSystem: 'Android 14',
	},
	posMini: {
		id: 'posMini',
		name: 'Frekuent spot Mini',
		image: miniImage,
		imageThumb: miniThumb,
		available: false,
		connectivity: [
			{ type: 'gsm', value: 'LTE, UMTS/HSPA, GSM/GPRS/EDGE' },
			{ type: 'wifi', value: 'WiFi 2.4/5 GHz' },
			{ type: 'bluetooth', value: 'Bluetooth 5.0' },
		],
		paymentMethods: ['card', 'google', 'apple', 'nfcTags', 'frekuentApp'],

		dimensions: '82 × 21 mm',
		ports: '1× USB 3.0-C + 1× RS232, 1× MDB Peripheral, NanoSIM + eSIM',
		nfcReader: 'ISO 14443-A/B, Mifare, FeliCa, EMVCo 3.1, Apple VAS',
		powerSupply: '34 VDC, 2 A',
		operatingSystem: 'Android 14',
	},
	posCompact: {
		id: 'posCompact',
		name: 'Frekuent spot Compact',
		image: compactImage,
		imageThumb: compactThumb,
		available: false,
		connectivity: [
			{ type: 'gsm', value: 'LTE, UMTS/HSPA, GSM/GPRS/EDGE' },
			{ type: 'wifi', value: 'WiFi 2.4/5 GHz' },
			{ type: 'bluetooth', value: 'Bluetooth 5.0' },
		],
		paymentMethods: ['card', 'google', 'apple', 'nfcTags', 'frekuentApp'],

		dimensions: '120 × 22 × 82 mm',
		ports: '1× USB 3.0-C + 1× RS232, 1× MDB Peripheral, NanoSIM + eSIM',
		nfcReader: 'ISO 14443-A/B, Mifare, FeliCa, EMVCo 3.1, Apple VAS',
		powerSupply: '34 VDC / 24 VAC, 2 A',
		operatingSystem: 'Android 14',
	},
	posMaster: {
		id: 'posMaster',
		name: 'Frekuent spot Master',
		image: masterImage,
		imageThumb: masterThumb,
		available: true,
		connectivity: [
			{ type: 'gsm', value: 'LTE, UMTS/HSPA, GSM/GPRS/EDGE' },
			{ type: 'wifi', value: 'WiFi 2.4/5 GHz' },
			{ type: 'bluetooth', value: 'Bluetooth 5.0' },
		],
		paymentMethods: ['card', 'google', 'apple', 'frekuentApp'],

		dimensions: '175 × 20 × 98 mm',
		ports: '1× USB-C OTG + 1× RS232 + 1× EXE/MDB Slave + 1× EXE/MDB Master',
		nfcReader: '', // TODO: confirm if posMaster has NFC reader
		powerSupply: '34 VDC / 24 VAC',
		operatingSystem: 'Android 10',
	},
};

export const MARKETPLACE_PRODUCTS_CATALOG: MarketplaceProductsCatalog = {
	devices: DEVICES_CATALOG,
	antennas: ANTENNAS_CATALOG,
};
